import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Skeleton, Select } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { setNodeSizeParam } from 'Actions/explore'
import { updateGraphNodes } from 'Actions/graph'
import { NodeSizeParams } from 'Model'
import { updateNodeSizeByAttribute } from 'Services/GraphUtils'
import WeaverService from 'Services/WeaverService'
import SizeService from 'Services/SizeService'

NodeSizeParamsSelector = ({ graphData, nodeSizeParam, setNodeSizeParam, updateGraphNodes, updateConfigNode }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [configNode, setConfigNode] = useState(undefined)
  [attList, setAttList] = useState([])

  useEffect( ->
    ( ->
      cNode = await NodeSizeParams.load()
      setConfigNode(cNode)
      setNodeSizeParam(await cNode.key())
      await getAndSetValidAttKeys()
      setLoading(false)
    )()
    undefined
  , [])

  updateGraphNodeSizes = (val) ->
    { groups, nodes } = graphData
    newGroups = {}
    newNodes = {}
    results = await new Weaver.Query().restrict(_.keys(nodes)).find()
    results.map((n) ->
      att = n.get(val)
      if att?
        newNodes[n.id()] = {
          nodes[n.id()]...,
          group: n.id()
        }
      newGroups[n.id()] = {
        size: SizeService.getNodeSizeByAttribute(att or 1)
      }
    )

    newGraphData = {
      nodes: newNodes
      groups: newGroups
    }
    updateGraphNodes(newGraphData)

  getAndSetValidAttKeys = ->
    result = await new Weaver.Sparql("""
      SELECT DISTINCT ?key ?datatype WHERE {
        ?node ?key ?val
        FILTER (isLiteral(?val))
        BIND(datatype(?val) AS ?datatype)
      }
    """).find()
    validKeys = result.key.filter((key, i) -> result.datatype[i].id() is 'double')
    setAttList(validKeys)

  save = (val) ->
    try
      await configNode.reset()
      await configNode.update(val)
    catch e
      console.log e
    setIsEditing(false)

  <Skeleton
    active
    paragraph={false}
    loading={loading}
  >
    <Select
      allowClear
      onSelect={(val) ->
        setNodeSizeParam(val)
        updateGraphNodeSizes(val)
        await save(val) if updateConfigNode
      }
      onClear={(val) ->
        setNodeSizeParam(val)
        updateGraphNodeSizes(val)
        await save(val) if updateConfigNode
      }
      value={nodeSizeParam}
      disabled={!WeaverService.userCanEdit()}
      placeholder="Attribute key to set node sizes by"
      bordered={false}
      style={{ width: '100%' }}
    >
      {
        attList.map((attributeKey) ->
          <Select.Option
            key={attributeKey.id()}
            value={attributeKey.id()}
          >
            { _.startCase(attributeKey.id()) }
          </Select.Option>
        )
      }
    </Select>
  </Skeleton>

export default connect(({ explore, graph }) ->
  {
    nodeSizeParam: explore.nodeSizeParam
    graphData: graph.graphData
  }
, { setNodeSizeParam, updateGraphNodes })(NodeSizeParamsSelector)

